import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3576faf0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row relative" }
const _hoisted_2 = {
  key: 0,
  class: "overlay-wrapper"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 d-flex flex-row justify-content-end align-items-center mt-3 mb-3" }, null, -1))
const _hoisted_4 = { class: "col-12 col-lg-5" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", { class: "text-uppercase font-size-sm font-weight-bold d-flex flex-row align-items-center" }, " Verfügbare Kontakte ", -1))
const _hoisted_6 = {
  key: 0,
  class: "alert alert-info"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mr-3 align-self-center" }, [
  /*#__PURE__*/_createElementVNode("a", { class: "btn bg-transparent border-blue text-blue rounded-pill border-2 btn-icon" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "icon-user text-blue" })
  ])
], -1))
const _hoisted_8 = { class: "media-body align-self-center" }
const _hoisted_9 = { class: "font-weight-bold" }
const _hoisted_10 = { class: "text-muted" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-phone2" }, null, -1))
const _hoisted_12 = { class: "media-right align-self-center mr-1" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-check" }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "bg-body mt-3" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mr-3" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "bg-transparent text-blue btn-icon"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "icon-plus2" })
  ])
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "media-body d-flex flex-row align-items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-blue" }, " Kontakte verwalten ")
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ml-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "list-icons text-blue" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "#",
      class: "list-icons-item"
    }, [
      /*#__PURE__*/_createElementVNode("i", { class: "icon-arrow-right15" })
    ])
  ])
], -1))
const _hoisted_20 = [
  _hoisted_17,
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = { class: "col-12 col-lg-7" }
const _hoisted_22 = { class: "text-uppercase font-size-sm font-weight-bold d-flex flex-row align-items-center justify-content-between" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Kontaktreihenfolge ")
const _hoisted_24 = { class: "media bg-white" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mr-3 align-self-center" }, [
  /*#__PURE__*/_createElementVNode("a", { class: "btn bg-transparent border-blue text-blue rounded-pill border-2 btn-icon" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "icon-user text-blue" })
  ])
], -1))
const _hoisted_26 = { class: "media-body align-self-center" }
const _hoisted_27 = { class: "font-weight-bold" }
const _hoisted_28 = { class: "text-muted" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-phone2" }, null, -1))
const _hoisted_30 = { class: "media-right align-self-center mr-1" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-cross" }, null, -1))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = {
  key: 1,
  class: "col-12 text-right"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_draggable = _resolveComponent("draggable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.shouldDisableInterventionChanges())
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : _createCommentVNode("", true),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createVNode(_Transition, { name: "slide-fade" }, {
        default: _withCtx(() => [
          (_ctx.contactOrder.length === 5)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, "Sie haben bereits alle 5 Kontakte ausgewählt"))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_draggable, {
        list: _ctx.availableContacts,
        "item-key": "index",
        tag: "ul",
        class: "media-list media-list-bordered bg-body text-dark p-3",
        group: "people",
        "ghost-class": "sortable-ghost",
        "drag-class": "sortable-drag",
        "chosen-class": "sortable-chosen",
        draggable: ".draggable"
      }, {
        item: _withCtx(({element}) => [
          _createElementVNode("li", {
            class: _normalizeClass(["media bg-white", _ctx.contactOrder.length < 5 ? 'draggable' : 'disabled'])
          }, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(element.firstName) + " " + _toDisplayString(element.lastName), 1),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createTextVNode(" " + _toDisplayString(element.phone), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("a", {
                class: "btn bg-light",
                onClick: _withModifiers(($event: any) => (_ctx.checkElement(element)), ["prevent"])
              }, _hoisted_15, 8, _hoisted_13)
            ])
          ], 2)
        ]),
        footer: _withCtx(() => [
          _createElementVNode("li", _hoisted_16, [
            _createElementVNode("a", {
              class: "media cursor-pointer align-items-center px-3",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToEmployees && _ctx.goToEmployees(...args)))
            }, _hoisted_20)
          ])
        ]),
        _: 1
      }, 8, ["list"])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("legend", _hoisted_22, [
        _hoisted_23,
        _createElementVNode("span", null, _toDisplayString(_ctx.contactOrder.length) + " von 5 Kontakten", 1)
      ]),
      _createVNode(_component_draggable, {
        list: _ctx.contactOrder,
        "item-key": "index",
        tag: "ul",
        class: "media-list media-list-bordered bg-body text-dark p-3",
        group: "people"
      }, {
        item: _withCtx(({element}) => [
          _createElementVNode("li", _hoisted_24, [
            _hoisted_25,
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, _toDisplayString(element.firstName) + " " + _toDisplayString(element.lastName), 1),
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                _createTextVNode(" " + _toDisplayString(element.phone), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("a", {
                class: "btn bg-light",
                onClick: _withModifiers(($event: any) => (_ctx.removeElement(element)), ["prevent"])
              }, _hoisted_33, 8, _hoisted_31)
            ])
          ])
        ]),
        _: 1
      }, 8, ["list"])
    ]),
    (_ctx.shouldDisableInterventionChanges())
      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary btn-sm",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.saveContacts && _ctx.saveContacts(...args)))
          }, "Kontakte speichern")
        ]))
      : _createCommentVNode("", true)
  ]))
}